import React from "react";
import { List } from "immutable";
import { Dropdown, Menu, Icon } from "antd";
// import { formatCurrency } from ".";
import { formatCurrency } from "../utils/currency";
import moment from "moment";

export const addActionColumn = cols =>
    cols.set("action", {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: 120
    });

export const addAction = (dataList, onClick, key, name = "View") =>
    dataList.map(_ => ({
        ..._,
        key: _[key],
        action: (
            <a href="javasrcipt:void(0)" onClick={() => onClick(_[key])}>
                {name}
            </a>
        )
    }));

export const addActionDropdown = (data, key, [first, ...rest]) => {
    return data.map(_ => ({
        ..._,
        key: _[key],
        action: (
            <Dropdown
                overlay={
                    <Menu>
                        {rest.map((action, index) => (
                            <Menu.Item key={index}>
                                <a
                                    href="javascript:void()"
                                    onClick={() => action.action(_[key])}
                                >
                                    {action.label}
                                </a>
                            </Menu.Item>
                        ))}
                    </Menu>
                }
            >
                <a
                    className="ant-dropdown-link"
                    href="javascript:void()"
                    onClick={() => first.action(_[key])}
                >
                    {first.label} <Icon type="down" />
                </a>
            </Dropdown>
        )
    }));
};
function getColumnRenderer(dataType, noDecimalShow) {
    switch (dataType) {
    case 4:
        return _ => moment(_).format("DD/MM/YYYY");
    case 6:
        return _ => formatCurrency(_, noDecimalShow, false);
    default:
        return _ => _;
    }
}

export const columnBuilder = (fields, noDecimalShow) =>
    new List(fields)
        .map(_ => ({
            title: _.display,
            dataIndex: _.data_key,
            key: _.data_key,
            order: _.sequence,
            dataType: _.data_type,
            render: getColumnRenderer(_.data_type, noDecimalShow),
            width: _.width || 200
        }))
        .sort((a, b) => {
            if (a.order > b.order) {
                return 1;
            }
            return -1;
        })
        .toOrderedMap()
        .mapEntries(([, v]) => [v.key, v]);

export const rowBuilder = _ =>
    new List(_).map((_, index) => ({ id: index, ..._ }));

export const filterBuilder = filters =>
    new List(filters)
        .map(_ => ({
            key: _.query_param_key,
            type: _.filter_type,
            selectType: _.url_search_type,
            selectLabelProp: _.filter_display_key,
            selectValueProp: _.query_param_value_field,
            selectOptionUrl: _.url,
            dataType: _.data_type,
            placeholder: _.display_label,
            defaultList: _.default_value_list
        }))
        .toOrderedMap()
        .mapEntries(([, v]) => [v.key, v]);

export const getScrollPercent = function(parentWidth, ownWidth) {
    if (parentWidth > ownWidth || parentWidth === 0) {
        return 0;
    } else {
        return ownWidth + 50;
    }
};
